var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/modal-close.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"o-modal__close-svg\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"109 -109.2 246.2 246.2\" style=\"enable-background:new 109 -109.2 246.2 246.2;\" xml:space=\"preserve\">\n    <title>Close modal</title>\n    <rect x=\"66.5\" y=\"5.4\" transform=\"matrix(-0.7071 -0.7071 0.7071 -0.7071 386.4859 187.81)\" width=\"331.2\" height=\"16.9\"></rect>\n    <rect x=\"223.6\" y=\"-151.7\" transform=\"matrix(-0.7071 -0.7071 0.7071 -0.7071 386.3651 187.76)\" width=\"16.9\" height=\"331.2\"></rect>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/modal-close.j2"] , dependencies)